export const sizes = {
  "container": {
    "sm": "40rem",
    "md": "48rem",
    "lg": "64rem",
    "xl": "80rem"
  },
  "largeSizes": {
    "3xs": "14rem",
    "2xs": "16rem",
    "xs": "20rem",
    "sm": "24rem",
    "md": "28rem",
    "lg": "32rem",
    "xl": "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "90rem",
    "prose": "60ch",
    "full": "100%",
    "max": "max-content",
    "min": "min-content"
  }
};